export default {
  label: {
    id: 'services_bouygues_offers_include_item5_title',
    defaultMessage:
      "Prêt gratuit d'un téléphone équivalent en cas de panne, perte, vol ou casse (même système d'exploitation)",
  },
}
